import { RenderGlobalNavOrUndefined } from '@eventbrite/global-nav';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { ConsumerHeader } from '../../../components/ConsumerHeader';
import { BasePage } from '../../base';
import { useAnalyticsAndMonitoring } from '../hooks/analytics';
import { useUpdatePageTitle } from '../hooks/dom';

export const CategoryBrowseBasePage: React.FunctionComponent<$FixMe> = (
    props,
) => {
    useUpdatePageTitle();
    useAnalyticsAndMonitoring();
    const { env, user, featureFlags } = props;

    const globalNavHeader = RenderGlobalNavOrUndefined({
        config: {
            env,
            user,
        },
        featureFlag: featureFlags?.enableIaGlobalNav,
    });

    return (
        <BasePage
            {...props}
            structureHeader={ConsumerHeader}
            overrideHeader={globalNavHeader}
        >
            {props.children}
        </BasePage>
    );
};
